import { REPORTS_TYPES } from 'constants/report';
import callAPiBase from './base';

const companyReportApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.CHARGE_MONTH_REPORT}`,
      method: 'GET',
      useToken: true,
      title: 'Company - Get List',
      params,
    }),

  importations: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: `/reports?reportType=${REPORTS_TYPES.CHARGE_VAN_FILE}`,
      method: 'GET',
      useToken: true,
      title: 'Company - Get Importations',
      params,
    }),
};

export { companyReportApi };
export default companyReportApi;
